module.exports = __webpack_public_path__ + "img/Abfahrk_status_schwererMangel.124d1a5b.svg";